export enum LaundryUserDetailsTab {
  OVERVIEW = 'overview',
  CALENDAR = 'calendar',
  ACCOUNT = 'account',
}
